(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-page"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    if (root.dataset.rpdInit) return;
    root.dataset.rpdInit = '1';

     var vInput = root.querySelector('[data-rpd-variant]');
    var plans  = root.querySelectorAll('[data-rpd-plan]');
    var firms  = root.querySelectorAll('[data-rpd-firm]');
    var prices = root.querySelectorAll('[data-rpd-cta-price]');
    var ctas   = root.querySelectorAll('.rpd-cta');

    var vdata = [];
    var vnode = root.querySelector('[data-rpd-variants]');
    if (vnode){ try { vdata = JSON.parse(vnode.textContent) || []; } catch(e){} }

    function norm(s){ return (s || '').toLowerCase().replace(/[^a-z0-9]/g, ''); }

    function matchVariant(planTxt, firmTxt){
      var a = norm(planTxt), b = norm(firmTxt), hit = null;
      vdata.forEach(function(v){
        var t = norm(v.t);
        if (a && t.indexOf(a) === -1) return;
        if (b && t.indexOf(b) === -1) return;
        if (!hit || (!hit.a && v.a)) hit = v;
      });
      return hit;
    }

    function sync(){
      var p = root.querySelector('[data-rpd-plan].rpd-plan-on') || plans[0];
      var f = root.querySelector('.rpd-firm-on') || firms[0];
      if (!p) return;

      var id = (f && f.getAttribute('data-vid')) || '';
      if (!id) id = p.getAttribute('data-vid') || '';
      if (!id && vdata.length){
        var m = matchVariant(
          p.getAttribute('data-match') || '',
          f ? (f.getAttribute('data-match') || '') : ''
        );
        if (m) id = String(m.id);
      }
      if (vInput && id) vInput.value = id;

      var pr = p.getAttribute('data-price');
      if (pr) prices.forEach(function(el){ el.textContent = pr; });

      if (vdata.length){
        var cur = null;
        vdata.forEach(function(v){ if (String(v.id) === String(id)) cur = v; });
        var out = !!(cur && !cur.a);
        ctas.forEach(function(b){
          if (b.tagName !== 'BUTTON') return;
          b.disabled = out;
          b.style.opacity = out ? '.55' : '';
          b.style.cursor = out ? 'not-allowed' : '';
        });
      }
    }

    plans.forEach(function(card){
      card.addEventListener('click', function(){
        plans.forEach(function(c){
          c.classList.remove('rpd-plan-on');
          var r = c.querySelector('input'); if (r) r.checked = false;
        });
        card.classList.add('rpd-plan-on');
        var r = card.querySelector('input'); if (r) r.checked = true;
        sync();
      });
    });
    firms.forEach(function(b){
      b.addEventListener('click', function(){
        firms.forEach(function(x){ x.classList.remove('rpd-firm-on'); });
        b.classList.add('rpd-firm-on');
        sync();
      });
    });
    sync();

    var gal = root.querySelector('[data-rpd-gal]');
    if (gal){
      var track  = gal.querySelector('[data-rpd-track]');
      var slides = gal.querySelectorAll('[data-rpd-slide]');
      var thumbs = gal.querySelectorAll('[data-rpd-thumb]');
      var tRow   = gal.querySelector('.rpd-thumbs');
      var cur    = -1;

      function mark(n){
        if (n === cur) return;
        cur = n;
        slides.forEach(function(s,i){ s.classList.toggle('rpd-on', i === n); });
        thumbs.forEach(function(x,i){ x.classList.toggle('rpd-thumb-on', i === n); });
        var at = thumbs[n];
        if (tRow && at){
          var want = at.offsetLeft - (tRow.clientWidth - at.offsetWidth) / 2;
          tRow.scrollTo({ left: Math.max(0, want), behavior: 'smooth' });
        }
      }

      thumbs.forEach(function(t){
        t.addEventListener('click', function(){
          var n = parseInt(t.getAttribute('data-rpd-thumb'), 10);
          var s = slides[n];
          if (track && s) track.scrollTo({ left: s.offsetLeft, behavior: 'smooth' });
          mark(n);
        });
      });

      if (track){
        var busy = null;
        track.addEventListener('scroll', function(){
          if (busy) return;
          busy = setTimeout(function(){
            busy = null;
            var w = track.clientWidth || 1;
            var n = Math.round(track.scrollLeft / w);
            if (n < 0) n = 0;
            if (n > slides.length - 1) n = slides.length - 1;
            mark(n);
          }, 80);
        }, {passive:true});
      }
      mark(0);
    }

    if ('IntersectionObserver' in window){
      var bars = root.querySelectorAll('[data-rpd-bar]');
      var bio = new IntersectionObserver(function(es){
        es.forEach(function(e){
          if (!e.isIntersecting || e.target.dataset.done) return;
          e.target.dataset.done = '1';
          var w = e.target.style.width;
          e.target.style.width = '0%';
          requestAnimationFrame(function(){
            requestAnimationFrame(function(){ e.target.style.width = w; });
          });
          bio.unobserve(e.target);
        });
      }, {threshold:.35});
      bars.forEach(function(b){ bio.observe(b); });

      var nums = root.querySelectorAll('[data-rpd-count]');
      var nio = new IntersectionObserver(function(es){
        es.forEach(function(e){
          if (!e.isIntersecting || e.target.dataset.done) return;
          e.target.dataset.done = '1';
          var raw = e.target.textContent.trim();
          var target = parseFloat(raw.replace(/[^0-9.]/g,''));
          if (isNaN(target)) return;
          var suf = raw.replace(/[0-9.,]/g,'');
          var t0 = null;
          function step(ts){
            if (!t0) t0 = ts;
            var pr = Math.min((ts-t0)/900, 1);
            e.target.textContent = Math.round(target*(1-Math.pow(1-pr,3))) + suf;
            if (pr < 1) requestAnimationFrame(step);
          }
          e.target.textContent = '0' + suf;
          requestAnimationFrame(step);
          nio.unobserve(e.target);
        });
      }, {threshold:.5});
      nums.forEach(function(n){ nio.observe(n); });
    }

    var timer = root.querySelector('[data-rpd-timer]');
    var dateEl = root.querySelector('[data-rpd-date]');
    if (timer){
      var days = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
      var months = ['January','February','March','April','May','June','July','August','September','October','November','December'];
      function ord(n){
        if (n > 3 && n < 21) return n + 'th';
        var r = n % 10;
        return n + (r === 1 ? 'st' : r === 2 ? 'nd' : r === 3 ? 'rd' : 'th');
      }
      function tick(){
        var now = new Date(), end = new Date(now);
        end.setHours(23,59,59,999);
        var d = end - now;
        var h = Math.floor(d/3600000), m = Math.floor((d%3600000)/60000), s = Math.floor((d%60000)/1000);
        timer.textContent = String(h).padStart(2,'0') + ':' + String(m).padStart(2,'0') + ':' + String(s).padStart(2,'0');
        if (dateEl){
          var lead = parseInt(dateEl.getAttribute('data-lead') || '3', 10);
          var del = new Date(now), added = 0;
          while (added < lead){
            del.setDate(del.getDate() + 1);
            if (del.getDay() !== 0 && del.getDay() !== 6) added++;
          }
          dateEl.textContent = days[del.getDay()] + ', ' + months[del.getMonth()] + ' ' + ord(del.getDate());
        }
      }
      tick(); setInterval(tick, 1000);
    }

          var cc = root.querySelector('[data-rpd-cartcount]');
    if (cc && window.fetch){
      var reCount = function(){
        fetch('/cart.js', {credentials:'same-origin'})
          .then(function(r){ return r.ok ? r.json() : null; })
          .then(function(c){
            if (!c) return;
            cc.textContent = c.item_count;
            cc.classList.toggle('rpd-hd-zero', !c.item_count);
          }).catch(function(){});
      };
      window.addEventListener('pageshow', function(e){ if (e.persisted) reCount(); });
      document.addEventListener('visibilitychange', function(){ if (!document.hidden) reCount(); });
      ['cart:updated','cart:refresh','cart:change'].forEach(function(ev){
        document.addEventListener(ev, reCount);
      });
    }

        var revRow = root.querySelector('[data-rpd-rev-row]');
    if (revRow){
      var revStep = function(){
        var c = revRow.querySelector('.rpd-top');
        return c ? c.offsetWidth + 14 : 300;
      };
      var rp = root.querySelector('[data-rpd-rev-prev]');
      var rn = root.querySelector('[data-rpd-rev-next]');
      if (rp) rp.addEventListener('click', function(){ revRow.scrollBy({left:-revStep(), behavior:'smooth'}); });
      if (rn) rn.addEventListener('click', function(){ revRow.scrollBy({left:revStep(), behavior:'smooth'}); });
    }

    var flag = root.querySelector('[data-rpd-flag]');
    if (flag){
      var card = flag.querySelector('[data-rpd-flag-card]');
      var pill = flag.querySelector('[data-rpd-flag-open]');
      var wasHidden = false;
      try { wasHidden = localStorage.getItem('rpd-flag-hidden') === '1'; } catch(e){}
      if (wasHidden) flag.style.display = 'none';

      var setOpen = function(on){
        flag.classList.toggle('rpd-flag-open', on);
        if (card) card.hidden = !on;
        if (pill) pill.setAttribute('aria-expanded', on ? 'true' : 'false');
      };
      if (pill) pill.addEventListener('click', function(){ setOpen(true); });
      var closeBtn = flag.querySelector('[data-rpd-flag-close]');
      if (closeBtn) closeBtn.addEventListener('click', function(){ setOpen(false); });
      var hideBtn = flag.querySelector('[data-rpd-flag-hide]');
      if (hideBtn) hideBtn.addEventListener('click', function(){
        flag.style.display = 'none';
        try { localStorage.setItem('rpd-flag-hidden','1'); } catch(e){}
      });
      document.addEventListener('keydown', function(e){
        if (e.key === 'Escape' && flag.classList.contains('rpd-flag-open')) setOpen(false);
      });
    }
    root.querySelectorAll('[data-rpd-vt]').forEach(function(box){
      var v = box.querySelector('video'), b = box.querySelector('.rpd-vt-play');
      if (!v || !b) return;
      b.addEventListener('click', function(){
        root.querySelectorAll('[data-rpd-vt] video').forEach(function(o){ if (o !== v) o.pause(); });
        v.controls = true;
        box.classList.add('rpd-vt-on');
        v.play();
      });
    });
    var sbar = root.querySelector('.rpd-sticky');
    var buy = root.querySelector('.rpd-col-buy');
    if (sbar && buy && 'IntersectionObserver' in window){
      new IntersectionObserver(function(es){
        sbar.classList.toggle('rpd-sticky-on', !es[0].isIntersecting);
      }, {threshold:0}).observe(buy);
    }
  }
  function all(r){ (r||document).querySelectorAll('.rpd').forEach(init); }
  all();
  document.addEventListener('shopify:section:load', function(e){ all(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reconnect-aditorial-page"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    if (root.dataset.rlpInit) return;
    root.dataset.rlpInit = '1';

    var tiers = root.querySelectorAll('[data-rlp-tier]');
    var vInput = root.querySelector('[data-rlp-variant]');
    var sticky = root.querySelector('[data-rlp-sticky]');

    function select(card){
      tiers.forEach(function(c){
        c.classList.remove('rlp-on');
        var r = c.querySelector('input'); if (r) r.checked = false;
      });
      card.classList.add('rlp-on');
      var r = card.querySelector('input'); if (r) r.checked = true;
      var v = card.getAttribute('data-variant');
      if (vInput && v) vInput.value = v;
      else if (!v) console.warn('RECONNECT: tier missing variant ID');
      var p = card.getAttribute('data-price');
      if (sticky && p) sticky.textContent = p;
    }
    tiers.forEach(function(c){ c.addEventListener('click', function(){ select(c); }); });
    var first = root.querySelector('[data-rlp-tier].rlp-on') || tiers[0];
    if (first) select(first);

    var nums = root.querySelectorAll('[data-rlp-count]');
    if ('IntersectionObserver' in window && nums.length){
      var io = new IntersectionObserver(function(es){
        es.forEach(function(e){
          if (!e.isIntersecting || e.target.dataset.done) return;
          e.target.dataset.done = '1';
          var raw = e.target.textContent.trim();
          var target = parseFloat(raw.replace(/[^0-9.]/g,''));
          if (isNaN(target)) return;
          var suffix = raw.replace(/[0-9.,]/g,'');
          var t0 = null;
          function step(ts){
            if (!t0) t0 = ts;
            var p = Math.min((ts-t0)/1000, 1);
            e.target.textContent = Math.round(target*(1-Math.pow(1-p,3))) + suffix;
            if (p < 1) requestAnimationFrame(step);
          }
          e.target.textContent = '0'+suffix;
          requestAnimationFrame(step);
          io.unobserve(e.target);
        });
      }, {threshold:.5});
         nums.forEach(function(n){ io.observe(n); });
    }

    root.querySelectorAll('[data-rlp-clip]').forEach(function(clip){
      var v = clip.querySelector('video');
      var fill = clip.querySelector('[data-rlp-clip-fill]');
      if (!v) return;
      v.muted = true; v.loop = true; v.playsInline = true;
      v.addEventListener('timeupdate', function(){
        if (fill && v.duration) fill.style.width = ((v.currentTime / v.duration) * 100) + '%';
      });
      clip.addEventListener('click', function(e){ e.preventDefault(); if (v.paused) v.play(); });
    });

    var bar = root.querySelector('[data-rlp-fill]');
    if (bar && 'IntersectionObserver' in window){
      var bio = new IntersectionObserver(function(es){
        es.forEach(function(e){
          if (!e.isIntersecting || e.target.dataset.done) return;
          e.target.dataset.done = '1';
          var w = e.target.style.width;
          e.target.style.width = '0%';
          e.target.style.transition = 'width 1.2s cubic-bezier(.22,1,.36,1)';
          requestAnimationFrame(function(){ requestAnimationFrame(function(){ e.target.style.width = w; }); });
          bio.unobserve(e.target);
        });
      }, {threshold:.4});
          bio.observe(bar);
    }

    var gal = root.querySelector('[data-rlp-gal]');
    if (gal){
      var slides = gal.querySelectorAll('[data-rlp-slide]');
      var thumbs = gal.querySelectorAll('[data-rlp-thumb]');
      var gi = 0;
      var gshow = function(n){
        if (!slides.length) return;
        gi = (n + slides.length) % slides.length;
        slides.forEach(function(s,i){ s.classList.toggle('rlp-gal-on', i === gi); });
        thumbs.forEach(function(t,i){ t.classList.toggle('rlp-thumb-on', i === gi); });
      };
      thumbs.forEach(function(t){
        t.addEventListener('click', function(){ gshow(parseInt(t.getAttribute('data-rlp-thumb'),10)); });
      });
      var gp = gal.querySelector('[data-rlp-prev]');
      var gn = gal.querySelector('[data-rlp-next]');
      if (gp) gp.addEventListener('click', function(){ gshow(gi - 1); });
      if (gn) gn.addEventListener('click', function(){ gshow(gi + 1); });
      var gx = null, gstage = gal.querySelector('.rlp-gal-stage');
      if (gstage){
        gstage.addEventListener('touchstart', function(e){ gx = e.changedTouches[0].clientX; }, {passive:true});
        gstage.addEventListener('touchend', function(e){
          if (gx === null) return;
          var dx = e.changedTouches[0].clientX - gx;
          if (Math.abs(dx) > 40) gshow(dx < 0 ? gi + 1 : gi - 1);
          gx = null;
        }, {passive:true});
      }
    }

    var cdEl = root.querySelector('[data-rlp-cd]');
    if (cdEl){
      var cdTick = function(){
        var now = new Date(), end = new Date(now);
        end.setHours(23,59,59,999);
        var d = end - now;
        cdEl.querySelector('[data-cd-h]').textContent = String(Math.floor(d/3600000)).padStart(2,'0');
        cdEl.querySelector('[data-cd-m]').textContent = String(Math.floor((d%3600000)/60000)).padStart(2,'0');
        cdEl.querySelector('[data-cd-s]').textContent = String(Math.floor((d%60000)/1000)).padStart(2,'0');
      };
         cdTick(); setInterval(cdTick, 1000);
    }

    var sbar = root.querySelector('.rlp-sticky');
    var offer = root.querySelector('#rlp-offer');
    if (sbar){
      var offerVisible = false;
      var update = function(){
        var doc = document.documentElement;
        var max = doc.scrollHeight - window.innerHeight;
        var past = max > 0 && (window.scrollY / max) > 0.10;
        sbar.classList.toggle('rlp-sticky-on', past && !offerVisible);
      };
      if (offer && 'IntersectionObserver' in window){
        new IntersectionObserver(function(es){
          offerVisible = es[0].isIntersecting;
          update();
        }, {threshold:0}).observe(offer);
      }
      window.addEventListener('scroll', update, {passive:true});
      window.addEventListener('resize', update, {passive:true});
      update();
    }
  }
  function all(r){ (r||document).querySelectorAll('.rlp').forEach(init); }
  all();
  document.addEventListener('shopify:section:load', function(e){ all(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reconnect-cart-page"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    if (root.dataset.rccInit) return;
    root.dataset.rccInit = '1';

    function change(line, qty, form){
      if (form) form.setAttribute('data-busy','1');
      fetch('/cart/change.js', {
        method:'POST',
        credentials:'same-origin',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify({ line:parseInt(line,10), quantity:Math.max(0, parseInt(qty,10) || 0) })
      }).then(function(r){
        if (!r.ok) throw new Error('bad');
        window.location.reload();
      }).catch(function(){
        if (form) form.removeAttribute('data-busy');
      });
    }

    var form = root.querySelector('#rcc-form');
    root.querySelectorAll('[data-rcc-qty]').forEach(function(b){
      b.addEventListener('click', function(){
        change(b.getAttribute('data-line'), b.getAttribute('data-q'), form);
      });
    });

    var code = root.querySelector('#rcc-code');
    var codeBtn = root.querySelector('#rcc-code-btn');
    function applyCode(){
      var v = (code && code.value || '').trim();
      if (!v) return;
      window.location.href = '/discount/' + encodeURIComponent(v) + '?redirect=' + encodeURIComponent('/cart');
    }
    if (codeBtn) codeBtn.addEventListener('click', applyCode);
    if (code) code.addEventListener('keydown', function(e){
      if (e.key === 'Enter'){ e.preventDefault(); applyCode(); }
    });

    var bar = root.querySelector('.rcc-ship-bar span');
    if (bar){
      var w = bar.style.width;
      bar.style.width = '0%';
      requestAnimationFrame(function(){
        requestAnimationFrame(function(){ bar.style.width = w; });
      });
    }
  }
  function all(r){ (r||document).querySelectorAll('.rcc').forEach(init); }
  all();
  document.addEventListener('shopify:section:load', function(e){ all(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reconnect-pillow-advertorial-page"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    if (root.dataset.rnpInit) return;
    root.dataset.rnpInit = '1';

    var vInput = root.querySelector('[data-rnp-variant]');
    var tiers  = root.querySelectorAll('[data-rnp-tier]');
    var firms  = root.querySelectorAll('[data-rnp-firm]');

    function currentSuffix(){
      var on = root.querySelector('.rnp-firm-on');
      return on ? (on.getAttribute('data-suffix') || '') : '';
    }
    function currentBase(){
      var on = root.querySelector('[data-rnp-tier].rnp-on') || tiers[0];
      return on ? (on.getAttribute('data-base') || '') : '';
    }
    function sync(){
      var base = currentBase(), suf = currentSuffix();
      var id = suf ? (base + suf) : base;
      if (vInput && base) vInput.value = id;
    }

    tiers.forEach(function(card){
      card.addEventListener('click', function(){
        tiers.forEach(function(c){
          c.classList.remove('rnp-on');
          var r = c.querySelector('input'); if (r) r.checked = false;
        });
        card.classList.add('rnp-on');
        var r = card.querySelector('input'); if (r) r.checked = true;
        sync();
      });
    });

    firms.forEach(function(btn){
      btn.addEventListener('click', function(){
        firms.forEach(function(b){ b.classList.remove('rnp-firm-on'); });
        btn.classList.add('rnp-firm-on');
        sync();
      });
    });
    sync();

    var gal = root.querySelector('[data-rnp-gal]');
    if (gal){
      var slides = gal.querySelectorAll('[data-rnp-slide]');
      var thumbs = gal.querySelectorAll('[data-rnp-thumb]');
      var gi = 0;
      function show(n){
        if (!slides.length) return;
        gi = (n + slides.length) % slides.length;
        slides.forEach(function(s,i){ s.classList.toggle('rnp-gal-on', i === gi); });
        thumbs.forEach(function(t,i){ t.classList.toggle('rnp-thumb-on', i === gi); });
      }
      thumbs.forEach(function(t){
        t.addEventListener('click', function(){ show(parseInt(t.getAttribute('data-rnp-thumb'),10)); });
      });
      var p = gal.querySelector('[data-rnp-prev]'), n = gal.querySelector('[data-rnp-next]');
      if (p) p.addEventListener('click', function(){ show(gi - 1); });
      if (n) n.addEventListener('click', function(){ show(gi + 1); });
      var x0 = null, stage = gal.querySelector('.rnp-gal-stage');
      if (stage){
        stage.addEventListener('touchstart', function(e){ x0 = e.changedTouches[0].clientX; }, {passive:true});
        stage.addEventListener('touchend', function(e){
          if (x0 === null) return;
          var dx = e.changedTouches[0].clientX - x0;
          if (Math.abs(dx) > 40) show(dx < 0 ? gi + 1 : gi - 1);
          x0 = null;
        }, {passive:true});
      }
    }

    if ('IntersectionObserver' in window){
      var bars = root.querySelectorAll('[data-rnp-bar]');
      var bio = new IntersectionObserver(function(es){
        es.forEach(function(e){
          if (!e.isIntersecting || e.target.dataset.done) return;
          e.target.dataset.done = '1';
          var w = e.target.style.width;
          e.target.style.width = '0%';
          requestAnimationFrame(function(){
            requestAnimationFrame(function(){ e.target.style.width = w; });
          });
          bio.unobserve(e.target);
        });
      }, {threshold:.35});
      bars.forEach(function(b){ bio.observe(b); });

      var nums = root.querySelectorAll('[data-rnp-count]');
      var nio = new IntersectionObserver(function(es){
        es.forEach(function(e){
          if (!e.isIntersecting || e.target.dataset.done) return;
          e.target.dataset.done = '1';
          var raw = e.target.textContent.trim();
          var target = parseFloat(raw.replace(/[^0-9.]/g,''));
          if (isNaN(target)) return;
          var pre = raw.indexOf('+') === 0 ? '+' : '';
          var suf = raw.replace(/[0-9.,+]/g,'');
          var t0 = null;
          function step(ts){
            if (!t0) t0 = ts;
            var pr = Math.min((ts-t0)/1000, 1);
            e.target.textContent = pre + Math.round(target*(1-Math.pow(1-pr,3))) + suf;
            if (pr < 1) requestAnimationFrame(step);
          }
          e.target.textContent = pre + '0' + suf;
          requestAnimationFrame(step);
          nio.unobserve(e.target);
        });
      }, {threshold:.5});
      nums.forEach(function(n){ nio.observe(n); });
    }

    var sbar = root.querySelector('.rnp-sticky');
    var offer = root.querySelector('#rnp-offer');
    if (sbar){
      var offerOn = false;
      var upd = function(){
        var doc = document.documentElement;
        var max = doc.scrollHeight - window.innerHeight;
        var past = max > 0 && (window.scrollY / max) > 0.10;
        sbar.classList.toggle('rnp-sticky-on', past && !offerOn);
      };
      if (offer && 'IntersectionObserver' in window){
        new IntersectionObserver(function(es){ offerOn = es[0].isIntersecting; upd(); }, {threshold:0}).observe(offer);
      }
      window.addEventListener('scroll', upd, {passive:true});
      window.addEventListener('resize', upd, {passive:true});
      upd();
    }
  }
  function all(r){ (r||document).querySelectorAll('.rnp').forEach(init); }
  all();
  document.addEventListener('shopify:section:load', function(e){ all(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reconnect-pillow-pdp"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    if (root.dataset.rpdInit) return;
    root.dataset.rpdInit = '1';

     var vInput = root.querySelector('[data-rpd-variant]');
    var plans  = root.querySelectorAll('[data-rpd-plan]');
    var firms  = root.querySelectorAll('[data-rpd-firm]');
    var prices = root.querySelectorAll('[data-rpd-cta-price]');
    var ctas   = root.querySelectorAll('.rpd-cta');

    var vdata = [];
    var vnode = root.querySelector('[data-rpd-variants]');
    if (vnode){ try { vdata = JSON.parse(vnode.textContent) || []; } catch(e){} }

    function norm(s){ return (s || '').toLowerCase().replace(/[^a-z0-9]/g, ''); }

    function matchVariant(planTxt, firmTxt){
      var a = norm(planTxt), b = norm(firmTxt), hit = null;
      vdata.forEach(function(v){
        var t = norm(v.t);
        if (a && t.indexOf(a) === -1) return;
        if (b && t.indexOf(b) === -1) return;
        if (!hit || (!hit.a && v.a)) hit = v;
      });
      return hit;
    }

    function sync(){
      var p = root.querySelector('[data-rpd-plan].rpd-plan-on') || plans[0];
      var f = root.querySelector('.rpd-firm-on') || firms[0];
      if (!p) return;

      var id = (f && f.getAttribute('data-vid')) || '';
      if (!id) id = p.getAttribute('data-vid') || '';
      if (!id && vdata.length){
        var m = matchVariant(
          p.getAttribute('data-match') || '',
          f ? (f.getAttribute('data-match') || '') : ''
        );
        if (m) id = String(m.id);
      }
      if (vInput && id) vInput.value = id;

      var pr = p.getAttribute('data-price');
      if (pr) prices.forEach(function(el){ el.textContent = pr; });

      if (vdata.length){
        var cur = null;
        vdata.forEach(function(v){ if (String(v.id) === String(id)) cur = v; });
        var out = !!(cur && !cur.a);
        ctas.forEach(function(b){
          if (b.tagName !== 'BUTTON') return;
          b.disabled = out;
          b.style.opacity = out ? '.55' : '';
          b.style.cursor = out ? 'not-allowed' : '';
        });
      }
    }

    plans.forEach(function(card){
      card.addEventListener('click', function(){
        plans.forEach(function(c){
          c.classList.remove('rpd-plan-on');
          var r = c.querySelector('input'); if (r) r.checked = false;
        });
        card.classList.add('rpd-plan-on');
        var r = card.querySelector('input'); if (r) r.checked = true;
        sync();
      });
    });
    firms.forEach(function(b){
      b.addEventListener('click', function(){
        firms.forEach(function(x){ x.classList.remove('rpd-firm-on'); });
        b.classList.add('rpd-firm-on');
        sync();
      });
    });
    sync();

    var gal = root.querySelector('[data-rpd-gal]');
    if (gal){
      var track  = gal.querySelector('[data-rpd-track]');
      var slides = gal.querySelectorAll('[data-rpd-slide]');
      var thumbs = gal.querySelectorAll('[data-rpd-thumb]');
      var tRow   = gal.querySelector('.rpd-thumbs');
      var cur    = -1;

      function mark(n){
        if (n === cur) return;
        cur = n;
        slides.forEach(function(s,i){ s.classList.toggle('rpd-on', i === n); });
        thumbs.forEach(function(x,i){ x.classList.toggle('rpd-thumb-on', i === n); });
        var at = thumbs[n];
        if (tRow && at){
          var want = at.offsetLeft - (tRow.clientWidth - at.offsetWidth) / 2;
          tRow.scrollTo({ left: Math.max(0, want), behavior: 'smooth' });
        }
      }

      thumbs.forEach(function(t){
        t.addEventListener('click', function(){
          var n = parseInt(t.getAttribute('data-rpd-thumb'), 10);
          var s = slides[n];
          if (track && s) track.scrollTo({ left: s.offsetLeft, behavior: 'smooth' });
          mark(n);
        });
      });

      if (track){
        var busy = null;
        track.addEventListener('scroll', function(){
          if (busy) return;
          busy = setTimeout(function(){
            busy = null;
            var w = track.clientWidth || 1;
            var n = Math.round(track.scrollLeft / w);
            if (n < 0) n = 0;
            if (n > slides.length - 1) n = slides.length - 1;
            mark(n);
          }, 80);
        }, {passive:true});
      }
      mark(0);
    }

    if ('IntersectionObserver' in window){
      var bars = root.querySelectorAll('[data-rpd-bar]');
      var bio = new IntersectionObserver(function(es){
        es.forEach(function(e){
          if (!e.isIntersecting || e.target.dataset.done) return;
          e.target.dataset.done = '1';
          var w = e.target.style.width;
          e.target.style.width = '0%';
          requestAnimationFrame(function(){
            requestAnimationFrame(function(){ e.target.style.width = w; });
          });
          bio.unobserve(e.target);
        });
      }, {threshold:.35});
      bars.forEach(function(b){ bio.observe(b); });

      var nums = root.querySelectorAll('[data-rpd-count]');
      var nio = new IntersectionObserver(function(es){
        es.forEach(function(e){
          if (!e.isIntersecting || e.target.dataset.done) return;
          e.target.dataset.done = '1';
          var raw = e.target.textContent.trim();
          var target = parseFloat(raw.replace(/[^0-9.]/g,''));
          if (isNaN(target)) return;
          var suf = raw.replace(/[0-9.,]/g,'');
          var t0 = null;
          function step(ts){
            if (!t0) t0 = ts;
            var pr = Math.min((ts-t0)/900, 1);
            e.target.textContent = Math.round(target*(1-Math.pow(1-pr,3))) + suf;
            if (pr < 1) requestAnimationFrame(step);
          }
          e.target.textContent = '0' + suf;
          requestAnimationFrame(step);
          nio.unobserve(e.target);
        });
      }, {threshold:.5});
      nums.forEach(function(n){ nio.observe(n); });
    }

    var timer = root.querySelector('[data-rpd-timer]');
    var dateEl = root.querySelector('[data-rpd-date]');
    if (timer){
      var days = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
      var months = ['January','February','March','April','May','June','July','August','September','October','November','December'];
      function ord(n){
        if (n > 3 && n < 21) return n + 'th';
        var r = n % 10;
        return n + (r === 1 ? 'st' : r === 2 ? 'nd' : r === 3 ? 'rd' : 'th');
      }
      function tick(){
        var now = new Date(), end = new Date(now);
        end.setHours(23,59,59,999);
        var d = end - now;
        var h = Math.floor(d/3600000), m = Math.floor((d%3600000)/60000), s = Math.floor((d%60000)/1000);
        timer.textContent = String(h).padStart(2,'0') + ':' + String(m).padStart(2,'0') + ':' + String(s).padStart(2,'0');
        if (dateEl){
          var lead = parseInt(dateEl.getAttribute('data-lead') || '3', 10);
          var del = new Date(now), added = 0;
          while (added < lead){
            del.setDate(del.getDate() + 1);
            if (del.getDay() !== 0 && del.getDay() !== 6) added++;
          }
          dateEl.textContent = days[del.getDay()] + ', ' + months[del.getMonth()] + ' ' + ord(del.getDate());
        }
      }
      tick(); setInterval(tick, 1000);
    }

          var cc = root.querySelector('[data-rpd-cartcount]');
    if (cc && window.fetch){
      var reCount = function(){
        fetch('/cart.js', {credentials:'same-origin'})
          .then(function(r){ return r.ok ? r.json() : null; })
          .then(function(c){
            if (!c) return;
            cc.textContent = c.item_count;
            cc.classList.toggle('rpd-hd-zero', !c.item_count);
          }).catch(function(){});
      };
      window.addEventListener('pageshow', function(e){ if (e.persisted) reCount(); });
      document.addEventListener('visibilitychange', function(){ if (!document.hidden) reCount(); });
      ['cart:updated','cart:refresh','cart:change'].forEach(function(ev){
        document.addEventListener(ev, reCount);
      });
    }

        var revRow = root.querySelector('[data-rpd-rev-row]');
    if (revRow){
      var revStep = function(){
        var c = revRow.querySelector('.rpd-top');
        return c ? c.offsetWidth + 14 : 300;
      };
      var rp = root.querySelector('[data-rpd-rev-prev]');
      var rn = root.querySelector('[data-rpd-rev-next]');
      if (rp) rp.addEventListener('click', function(){ revRow.scrollBy({left:-revStep(), behavior:'smooth'}); });
      if (rn) rn.addEventListener('click', function(){ revRow.scrollBy({left:revStep(), behavior:'smooth'}); });
    }

    var flag = root.querySelector('[data-rpd-flag]');
    if (flag){
      var card = flag.querySelector('[data-rpd-flag-card]');
      var pill = flag.querySelector('[data-rpd-flag-open]');
      var wasHidden = false;
      try { wasHidden = localStorage.getItem('rpd-flag-hidden') === '1'; } catch(e){}
      if (wasHidden) flag.style.display = 'none';

      var setOpen = function(on){
        flag.classList.toggle('rpd-flag-open', on);
        if (card) card.hidden = !on;
        if (pill) pill.setAttribute('aria-expanded', on ? 'true' : 'false');
      };
      if (pill) pill.addEventListener('click', function(){ setOpen(true); });
      var closeBtn = flag.querySelector('[data-rpd-flag-close]');
      if (closeBtn) closeBtn.addEventListener('click', function(){ setOpen(false); });
      var hideBtn = flag.querySelector('[data-rpd-flag-hide]');
      if (hideBtn) hideBtn.addEventListener('click', function(){
        flag.style.display = 'none';
        try { localStorage.setItem('rpd-flag-hidden','1'); } catch(e){}
      });
      document.addEventListener('keydown', function(e){
        if (e.key === 'Escape' && flag.classList.contains('rpd-flag-open')) setOpen(false);
      });
    }
    root.querySelectorAll('[data-rpd-vt]').forEach(function(box){
      var v = box.querySelector('video'), b = box.querySelector('.rpd-vt-play');
      if (!v || !b) return;
      b.addEventListener('click', function(){
        root.querySelectorAll('[data-rpd-vt] video').forEach(function(o){ if (o !== v) o.pause(); });
        v.controls = true;
        box.classList.add('rpd-vt-on');
        v.play();
      });
    });
    var sbar = root.querySelector('.rpd-sticky');
    var buy = root.querySelector('.rpd-col-buy');
    if (sbar && buy && 'IntersectionObserver' in window){
      new IntersectionObserver(function(es){
        sbar.classList.toggle('rpd-sticky-on', !es[0].isIntersecting);
      }, {threshold:0}).observe(buy);
    }
  }
  function all(r){ (r||document).querySelectorAll('.rpd').forEach(init); }
  all();
  document.addEventListener('shopify:section:load', function(e){ all(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reconnect-product-page"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initPage(page){
    if (page.dataset.rp2Init) return;
    page.dataset.rp2Init = 'true';

    // tier selector - drives BOTH the sticky price and the cart variant
    var tiers = page.querySelectorAll('[data-rp2-plan]');
    var variantInput = page.querySelector('[data-rp2-variant-input]');
    var stickyPrice = page.querySelector('[data-rp2-sticky-price]');
    tiers.forEach(function(card){
      card.addEventListener('click', function(){
        tiers.forEach(function(c){
          c.classList.remove('rp2-selected');
          var r = c.querySelector('input');
          if (r) r.checked = false;
        });
        card.classList.add('rp2-selected');
        var radio = card.querySelector('input');
        if (radio) radio.checked = true;
        var vid = card.getAttribute('data-rp2-variant');
        if (variantInput && vid) variantInput.value = vid;
        var label = card.getAttribute('data-rp2-sticky');
        if (stickyPrice && label) stickyPrice.textContent = label;
      });
    });
    // sync the form to whichever tier starts selected
    var initial = page.querySelector('[data-rp2-plan].rp2-selected') || tiers[0];
    if (initial){
      var iv = initial.getAttribute('data-rp2-variant');
      if (variantInput && iv) variantInput.value = iv;
      var il = initial.getAttribute('data-rp2-sticky');
      if (stickyPrice && il) stickyPrice.textContent = il;
    }

    // hero gallery
    var gal = page.querySelector('[data-rp2-gallery]');
    if (gal){
      var slides = gal.querySelectorAll('[data-rp2-slide]');
      var thumbs = gal.querySelectorAll('[data-rp2-thumb]');
      var idx = 0;
      function show(n){
        if (!slides.length) return;
        idx = (n + slides.length) % slides.length;
        slides.forEach(function(sl, i){ sl.classList.toggle('rp2-active', i === idx); });
        thumbs.forEach(function(tb, i){ tb.classList.toggle('rp2-active', i === idx); });
        var active = gal.querySelector('[data-rp2-thumb="' + idx + '"]');
        if (active && active.scrollIntoView) active.scrollIntoView({block:'nearest', inline:'nearest'});
      }
      thumbs.forEach(function(tb){
        tb.addEventListener('click', function(){ show(parseInt(tb.getAttribute('data-rp2-thumb'), 10)); });
      });
      var prev = gal.querySelector('[data-rp2-prev]');
      var next = gal.querySelector('[data-rp2-next]');
      if (prev) prev.addEventListener('click', function(){ show(idx - 1); });
      if (next) next.addEventListener('click', function(){ show(idx + 1); });
      var x0 = null;
      var stage = gal.querySelector('.rp2-hero-stage');
      if (stage){
        stage.addEventListener('touchstart', function(e){ x0 = e.changedTouches[0].clientX; }, {passive:true});
        stage.addEventListener('touchend', function(e){
          if (x0 === null) return;
          var dx = e.changedTouches[0].clientX - x0;
          if (Math.abs(dx) > 40) show(dx < 0 ? idx + 1 : idx - 1);
          x0 = null;
        }, {passive:true});
      }
    }

    // buy-box clips
    page.querySelectorAll('[data-rp2-clip]').forEach(function(clip){
      var vid = clip.querySelector('video');
      var fill = clip.querySelector('[data-rp2-clip-fill]');
      if (!vid) return;
      vid.muted = true; vid.loop = true; vid.playsInline = true;
      vid.addEventListener('timeupdate', function(){
        if (fill && vid.duration) fill.style.width = ((vid.currentTime / vid.duration) * 100) + '%';
      });
            clip.addEventListener('click', function(e){
        e.preventDefault();
        if (vid.paused) vid.play();
      });
    });

    // count-up on scroll: survey percentages + stock bar
        var counters = page.querySelectorAll('.rp2-survey-pct, .rp2-sci-pct, .rp2-stock-count b');
    var bars = page.querySelectorAll('.rp2-stock-fill');

    function countUp(el){
      var raw = el.textContent.trim();
      var target = parseFloat(raw.replace(/[^0-9.]/g, ''));
      if (isNaN(target)) return;
      var suffix = raw.replace(/[0-9.,]/g, '');
      var start = null, dur = 1100;
      function step(ts){
        if (!start) start = ts;
        var p = Math.min((ts - start) / dur, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = Math.round(target * eased) + suffix;
        if (p < 1) requestAnimationFrame(step);
      }
      el.textContent = '0' + suffix;
      requestAnimationFrame(step);
    }

    function fillBar(el){
      var w = el.style.width;
      el.style.width = '0%';
      el.style.transition = 'width 1.2s cubic-bezier(.22,1,.36,1)';
      requestAnimationFrame(function(){
        requestAnimationFrame(function(){ el.style.width = w; });
      });
    }

    if ('IntersectionObserver' in window){
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(entry){
          if (!entry.isIntersecting || entry.target.dataset.rp2Counted) return;
          entry.target.dataset.rp2Counted = '1';
          if (entry.target.classList.contains('rp2-stock-fill')) fillBar(entry.target);
          else countUp(entry.target);
          io.unobserve(entry.target);
        });
      }, {threshold: 0.4});
      counters.forEach(function(el){ io.observe(el); });
      bars.forEach(function(el){ io.observe(el); });
    }

    // accordions
    page.querySelectorAll('.rp2-acc-head').forEach(function(head){
      head.addEventListener('click', function(){
        var item = head.parentElement;
        var body = item.querySelector('.rp2-acc-body');
        var wasOpen = item.classList.contains('rp2-open');
        item.classList.toggle('rp2-open');
        body.style.maxHeight = wasOpen ? null : body.scrollHeight + 'px';
      });
    });

    // countdown (daily reset)
    var cd = page.querySelector('[data-rp2-countdown]');
    if (cd){
      function tick(){
        var now = new Date(); var end = new Date(now); end.setHours(23,59,59,999);
        var diff = end - now;
        var h = Math.floor(diff/3600000), m = Math.floor((diff%3600000)/60000), s = Math.floor((diff%60000)/1000);
        cd.querySelector('[data-cd-h]').textContent = String(h).padStart(2,'0');
        cd.querySelector('[data-cd-m]').textContent = String(m).padStart(2,'0');
        cd.querySelector('[data-cd-s]').textContent = String(s).padStart(2,'0');
      }
      tick(); setInterval(tick, 1000);
    }
  }
  function initAll(root){ (root || document).querySelectorAll('.rp2-page').forEach(initPage); }
  initAll();
  document.addEventListener('shopify:section:load', function(evt){ initAll(evt.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reconnect-quiz"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initQuiz(page){
    if (page.dataset.rqInitialized) return;
    page.dataset.rqInitialized = 'true';
    var cfgEl = page.parentElement.querySelector('[data-rq-config]');
    var screenEl = page.querySelector('[data-rq-screen]');
    if (!cfgEl){
      if (screenEl) screenEl.innerHTML = '<p style="color:#f66;font-family:monospace;font-size:12px;">RECONNECT quiz: config script tag not found next to the section. Check that reconnect-quiz.liquid was saved correctly.</p>';
      return;
    }
    var cfg;
    try {
      cfg = JSON.parse(cfgEl.textContent);
    } catch(e){
      if (screenEl) screenEl.innerHTML = '<p style="color:#f66;font-family:monospace;font-size:12px;white-space:pre-wrap;">RECONNECT quiz: could not parse config JSON.\n\n'+ (e && e.message ? e.message : e) +'\n\nThis usually means the reconnect-quiz.liquid file in your theme is out of date, or a setting contains unescaped text. Re-paste the latest file and save.</p>';
      return;
    }
    if (!cfg.questions || !cfg.questions.length){
      if (screenEl) screenEl.innerHTML = '<p style="color:#f66;font-family:monospace;font-size:12px;">RECONNECT quiz: no question blocks found. Add at least one "Question" block to this section in the theme customizer.</p>';
      return;
    }
    var progressTrack = page.querySelector('[data-rq-progress-track]');
    var progressFill = page.querySelector('[data-rq-progress-fill]');
    var answers = {};
    var current = 0;
    var questionCount = 0;

    function fmtDateOffset(days){
      var d = new Date(); d.setDate(d.getDate() + days);
      var months = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
      return months[d.getMonth()] + " " + d.getDate();
    }
    function checkSVG(){ return '<svg viewBox="0 0 24 24" fill="none"><path d="M20 6L9 17l-5-5" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg>'; }

    function highlightAccent(text, accent){
      if (!accent) return text;
      var idx = text.toLowerCase().indexOf(accent.toLowerCase());
      if (idx === -1) return text;
      var real = text.substring(idx, idx + accent.length);
      return text.substring(0, idx) + '<span class="rq-accent">' + real + '</span>' + text.substring(idx + accent.length);
    }

    function renderOptions(opts){
      var html = '<div class="rq-options">';
      opts.forEach(function(label, i){
        html += '<button class="rq-opt" data-idx="'+i+'" data-label="'+String(label).replace(/"/g,'&quot;')+'">'+label+'</button>';
      });
      return html + '</div>';
    }
    function bindOptionClicks(onPick){
      var opts = screenEl.querySelectorAll('.rq-opt');
      opts.forEach(function(btn){
        btn.addEventListener('click', function(){
          opts.forEach(function(b){ b.classList.remove('rq-selected'); });
          btn.classList.add('rq-selected');
          setTimeout(function(){ onPick(btn.getAttribute('data-label')); }, 220);
        });
      });
    }
    function updateProgress(){
      if (questionCount > 0){
        progressTrack.style.display = 'block';
        var pct = Math.min(100, (questionCount / (cfg.questionTotal || 1)) * 100);
        progressFill.style.width = pct + '%';
      } else { progressTrack.style.display = 'none'; }
    }

    // build the full screen sequence from config
    var sequence = [];
    sequence.push({type:'intro-question', q: cfg.questions[0]});
    for (var i = 1; i < cfg.questions.length; i++){
      sequence.push({type:'question', q: cfg.questions[i]});
      if (i === (cfg.revealAfter - 1)){
        sequence.push({type:'loading-ring'});
        sequence.push({type:'result'});
        sequence.push({type:'loading-checklist', data: cfg.loading2});
        sequence.push({type:'social-proof'});
      }
    }
    sequence.push({type:'chart'});
    sequence.push({type:'loading-checklist', data: cfg.loading3});
    sequence.push({type:'offer'});

    function renderQuestionScreen(q){
      questionCount++;
      var html = '<h1 class="rq-h">'+q.title+'</h1>' + renderOptions(q.options);
      if (q.why){ html += '<div class="rq-why"><div class="rq-lbl">Why we ask</div><p>'+q.why+'</p></div>'; }
      screenEl.innerHTML = html;
      bindOptionClicks(function(label){ answers[q.title] = label; showScreen(current+1); });
    }

    function renderIntro(q){
      questionCount = 1;
      var avatarInner = cfg.intro.testimonialImage
        ? '<img src="'+cfg.intro.testimonialImage+'" alt="'+cfg.intro.testimonialName+'">'
        : (cfg.intro.testimonialName ? cfg.intro.testimonialName.charAt(0) : 'S');
      screenEl.innerHTML = ''+
        '<h1 class="rq-h">'+highlightAccent(cfg.intro.headline, cfg.intro.headlineAccent)+'</h1>'+
        '<div class="rq-check-line"><span class="rq-box">'+checkSVG()+'</span><span>'+cfg.intro.checkline+'</span></div>'+
        '<div class="rq-testi"><div class="rq-avatar">'+avatarInner+'</div><div><div class="rq-body">"'+cfg.intro.testimonialQuote+'"</div><div class="rq-who"><span class="rq-who-check">'+checkSVG()+'</span> '+cfg.intro.testimonialName+'</div></div></div>'+
        '<h2 style="font-family:Archivo,Arial,sans-serif;font-weight:800;text-transform:uppercase;font-size:19px;margin:0 0 14px;">'+q.title+'</h2>'+
        renderOptions(q.options);
      bindOptionClicks(function(label){ answers[q.title] = label; showScreen(current+1); });
    }

    function renderLoadingRing(){
      screenEl.innerHTML = ''+
        '<h1 class="rq-h" style="text-align:center;">'+cfg.loading1.title+'</h1>'+
        '<p class="rq-sub" style="text-align:center;">'+cfg.loading1.sub+'</p>'+
        '<div class="rq-ring-wrap"><div class="rq-ring"><svg viewBox="0 0 150 150"><circle class="rq-track" cx="75" cy="75" r="64"></circle><circle class="rq-fill" data-ring-fill cx="75" cy="75" r="64" stroke-dasharray="402" stroke-dashoffset="402"></circle></svg><div class="rq-ring-label"><div class="rq-ring-pct" data-ring-pct>0%</div><div class="rq-ring-sub">Analyzing</div></div></div></div>';
      var fillEl = screenEl.querySelector('[data-ring-fill]');
      var pctEl = screenEl.querySelector('[data-ring-pct]');
      var pct = 0;
      var interval = setInterval(function(){
        pct += Math.floor(Math.random()*9)+6;
        if (pct >= 100){ pct = 100; clearInterval(interval); }
        fillEl.style.strokeDashoffset = 402 - (402*pct/100);
        pctEl.textContent = pct + '%';
        if (pct === 100){ setTimeout(function(){ showScreen(current+1); }, 500); }
      }, 220);
    }

    function renderLoadingChecklist(data){
      var items = (data.items || []).filter(Boolean);
      var itemsHtml = items.map(function(txt){
        return '<div class="rq-loading-item"><div class="rq-loading-icon">&#128274;</div><div class="rq-loading-txt">'+txt+'</div><div class="rq-loading-spinner"></div><div class="rq-loading-check">'+checkSVG()+'</div></div>';
      }).join('');
      screenEl.innerHTML = '<h1 class="rq-h">'+data.title+'</h1><p class="rq-sub">'+data.sub+'</p><div class="rq-loading-list">'+itemsHtml+'</div><div class="rq-loading-footer">'+data.footer+'</div>';
      var els = screenEl.querySelectorAll('.rq-loading-item');
      var i = 0;
      function step(){
        if (i > 0){ els[i-1].classList.remove('rq-active'); els[i-1].classList.add('rq-done'); }
        if (i < els.length){ els[i].classList.add('rq-active'); i++; setTimeout(step, 550); }
        else { setTimeout(function(){ showScreen(current+1); }, 500); }
      }
      setTimeout(step, 300);
    }

    function renderResult(){
      var r = cfg.result;
      screenEl.innerHTML = ''+
        '<div class="rq-card-white"><div class="rq-badge-alert">!</div><div class="rq-result-title">'+r.badge+'</div><div class="rq-pill">Restricted</div><p class="rq-desc">'+r.description+'</p></div>'+
        '<div class="rq-card-white"><div class="rq-severity-label">'+r.severityLabel+'</div><div class="rq-severity-badge">Severe</div><div class="rq-severity-track"><div class="rq-severity-dot"></div></div><div class="rq-severity-labels"><span>Low</span><span>High</span></div>'+
        '<div class="rq-fact-grid">'+
          '<div class="rq-fact"><div class="rq-lbl">'+r.fact1Label+'</div><div class="rq-val">'+r.fact1Value+'</div></div>'+
          '<div class="rq-fact rq-alt"><div class="rq-lbl">'+r.fact2Label+'</div><div class="rq-val">'+r.fact2Value+'</div></div>'+
          '<div class="rq-fact"><div class="rq-lbl">'+r.fact3Label+'</div><div class="rq-val">'+r.fact3Value+'</div></div>'+
          '<div class="rq-fact rq-alt"><div class="rq-lbl">'+r.fact4Label+'</div><div class="rq-val">'+r.fact4Value+'</div></div>'+
        '</div></div>'+
        '<button class="rq-cta" data-result-cta>'+r.ctaText+'</button>';
      screenEl.querySelector('[data-result-cta]').addEventListener('click', function(){ showScreen(current+1); });
    }

    function renderSocialProof(){
      var s = cfg.socialProof;
      function testiCard(img, quote, name){
        var photoInner = img ? '<img src="'+img+'" alt="'+name+'">' : (name ? name.charAt(0) : '?');
        return '<div class="rq-social-card">'+
          '<div class="rq-social-photo">'+photoInner+'</div>'+
          '<p class="rq-social-quote">"'+quote+'"</p>'+
          '<div class="rq-social-name">'+name+'</div>'+
        '</div>';
      }
      screenEl.innerHTML = ''+
        '<h1 class="rq-h">'+s.headline+'</h1><p class="rq-sub">'+s.sub+'</p>'+
        '<button class="rq-cta" data-sp-cta>CONTINUE</button>'+
        '<div class="rq-social-grid">'+
          testiCard(s.testimonial1Image, s.testimonial1Quote, s.testimonial1Name)+
          testiCard(s.testimonial2Image, s.testimonial2Quote, s.testimonial2Name)+
        '</div>';
      screenEl.querySelector('[data-sp-cta]').addEventListener('click', function(){ showScreen(current+1); });
    }

    function renderChart(){
      var c = cfg.chart;
      var eta = fmtDateOffset(c.etaDays || 21);
      var d7 = fmtDateOffset(7), d14 = fmtDateOffset(14);
      screenEl.innerHTML = ''+
        '<h1 class="rq-h">'+c.headline+'</h1>'+
        '<p class="rq-sub">Based on your answers, we expect your airflow to open by <b style="color:var(--rq-orange);">'+eta+'</b>.</p>'+
        '<div class="rq-chart-card">'+
          '<div class="rq-chart-meta"><div class="rq-m"><div class="rq-k">Status</div><div class="rq-v">Restricted Airway</div></div><div class="rq-m"><div class="rq-k">Projected Lift</div><div class="rq-v rq-orange">'+c.projectedLift+'</div></div><div class="rq-m"><div class="rq-k">ETA</div><div class="rq-v">'+eta+'</div></div></div>'+
          '<svg viewBox="0 0 400 180" width="100%" height="auto"><defs><linearGradient id="rqGrad-'+cfg.brand+'" x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stop-color="#FF5A1F" stop-opacity="0.45"/><stop offset="100%" stop-color="#FF5A1F" stop-opacity="0"/></linearGradient></defs>'+
          '<path d="M10,150 C120,150 180,60 390,20" fill="none" stroke="#FF5A1F" stroke-width="3"/><path d="M10,150 C120,150 180,60 390,20 L390,170 L10,170 Z" fill="url(#rqGrad-'+cfg.brand+')"/>'+
          '<circle cx="10" cy="150" r="6" fill="#0a0a0a" stroke="#FF5A1F" stroke-width="3"/><circle cx="390" cy="20" r="6" fill="#FF5A1F"/>'+
          '<text x="14" y="140" fill="#fff" font-size="11" font-family="Inter">You are here</text><text x="255" y="14" fill="#FF5A1F" font-size="11" font-family="Inter" font-weight="700">Goal</text></svg>'+
          '<div class="rq-chart-axis"><span>Today</span><span>'+d7+'</span><span>'+d14+'</span><span>'+eta+'</span></div>'+
        '</div>'+
        '<button class="rq-cta" data-chart-cta>'+c.ctaText+'</button>';
      screenEl.querySelector('[data-chart-cta]').addEventListener('click', function(){ showScreen(current+1); });
    }

    function renderOffer(){
      var o = cfg.offer;
      screenEl.innerHTML = ''+
        '<h1 class="rq-h" style="text-align:center;">'+o.headline+'</h1>'+
        '<p class="rq-guarantee">'+o.guaranteeBody+'<span class="rq-refund">'+o.refundLine+'</span></p>'+
        '<div class="rq-product-card">'+
          '<div class="rq-product-badge">'+o.badgeText+'</div>'+
          '<div class="rq-sold-badge">'+o.soldBadge+'</div>'+
          (cfg.productImage ? '<div class="rq-product-img-wrap"><img src="'+cfg.productImage+'" alt="'+cfg.brand+'"></div>' : '')+
          '<div class="rq-icon-grid"><div class="rq-icon-item"><div class="rq-icon-circle">&#9889;</div><span>Instant Airflow</span></div><div class="rq-icon-item"><div class="rq-icon-circle">&#127769;</div><span>Quieter Nights</span></div><div class="rq-icon-item"><div class="rq-icon-circle">&#128564;</div><span>Deeper Sleep</span></div><div class="rq-icon-item"><div class="rq-icon-circle">&#10084;&#65039;</div><span>Restored Intimacy</span></div></div>'+
        '</div>'+
        '<a class="rq-cta" href="'+cfg.nextUrl+'">'+o.ctaText+'</a>'+
        '<div class="rq-fine">'+o.fineprint+'</div>';
    }

    function showScreen(idx){
      if (idx >= sequence.length) idx = sequence.length - 1;
      current = idx;
      var step = sequence[idx];
      page.scrollIntoView({behavior:'smooth', block:'start'});
      switch(step.type){
        case 'intro-question': questionCount = 0; renderIntro(step.q); updateProgress(); break;
        case 'question': renderQuestionScreen(step.q); updateProgress(); break;
        case 'loading-ring': progressTrack.style.display='none'; renderLoadingRing(); break;
        case 'loading-checklist': progressTrack.style.display='none'; renderLoadingChecklist(step.data); break;
        case 'result': progressTrack.style.display='none'; renderResult(); break;
        case 'social-proof': progressTrack.style.display='none'; renderSocialProof(); break;
        case 'chart': progressTrack.style.display='none'; renderChart(); break;
        case 'offer': progressTrack.style.display='none'; renderOffer(); break;
      }
    }

    try {
      showScreen(0);
    } catch(e){
      screenEl.innerHTML = '<p style="color:#f66;font-family:monospace;font-size:12px;white-space:pre-wrap;">RECONNECT quiz: JS error while rendering.\n\n'+ (e && e.message ? e.message : e) +'</p>';
    }
  }

  function initAll(root){
    (root || document).querySelectorAll('.rq-page').forEach(initQuiz);
  }

  initAll();

  // Re-init when the theme customizer swaps in fresh section HTML
  // (e.g. after adding/saving blocks) without a full page reload.
  document.addEventListener('shopify:section:load', function(evt){
    initAll(evt.target);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
